<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001108') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select
								:value="searchParams.cpnyScn"
								@change="val => changeSelect(val, 'cpnyScn')"
								:placeholder="getMessage_('QWCC001108')"
							>
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in cpnyScnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000951')"
						paramKey="cpnyNm"
						@commInput="change"
						:propData="searchParams.cpnyNm"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001163') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.useYn" @change="val => changeSelect(val, 'useYn')" :placeholder="getMessage_('QWCC001163')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in useYnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>
			</el-row>
			<!--초기화-->
			<template slot="button">
				<sf-button line :onClick="() => searchInit()" v-if="isButton_(scrId, 'CR')" class="icon-sf-refresh">
					{{ getMessage_('QWCC001109') }}
				</sf-button>
				<!--조회-->
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		async changeSelect(val, key) {
			await this.setSearchParam_({ key: key, value: val });
		},
		async change(param) {
			await this.setSearchParam_(param);
		},
		//조회 이벤트
		searchList() {
			this.$sf_toggleLoading(true);
			this.getCompMst_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			this.setStateClear_();
		},
		//초기화 이벤트
		searchInit() {
			this.setSearchInit_();
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }); //사용여부 공통코드
			await this.getCommCodes_({ key: 'compMst', codeType: 'CPNY_SCN' }); //업체구분 공통코드

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
